import { render, staticRenderFns } from "./UpdateCustomer.vue?vue&type=template&id=a28713ac&scoped=true&"
import script from "./UpdateCustomer.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28713ac",
  null
  
)

export default component.exports